// extracted by mini-css-extract-plugin
export default {"main_info_component":"maincomponent_main_info_component__paCFx","main_para":"maincomponent_main_para__Y-ibF","readmore":"maincomponent_readmore__1oXDH"};